import {Directive, HostListener, Input} from '@angular/core';
import {DataLayerParamsClickGA4} from '../types/DataLayerParamsClickGA4';
import {GtmGa4EventPushService} from '../services/gtm-ga4-event-push.service';

@Directive({
  selector: '[appGtmGa4Event]',
})
export class GtmGa4EventDirective {
  @Input() eventParams: DataLayerParamsClickGA4;

  constructor(private gtmEventPush: GtmGa4EventPushService) {}

  @HostListener('click', ['$event']) onClick($event) {
    this.clickRegister();
  }

  private clickRegister(): void {
    this.gtmEventPush.pushClickEvent(this.eventParams);
  }
}
